<template>
    <div>
        <!-- 轮播图 -->
        <div class="header">
            <div class="header-tag">Cases</div>
            <!-- <div class="header-title">成功案例</div> -->
        </div>
        <!-- 成功案例 -->
        <div class="" style="margin: 60px 0;">
            <div class="">
                <div class="w1 flex-row align-center justify-between"  v-for="(item, index) in CustomerSolutionData">
                <div class="basis-df">
                    <img :src="http.ipAddress+item.filePath"
                                style="width: 300;height: 300px;" alt="">
                    </div>
                    <div class="basis-df" style="margin-left: 0px;position: relative;">
                        <div style="margin-bottom: 20px;">{{item.ettribute1}}</div>
                        <p>{{item.ettribute2}}</p>
                            <!-- <img src="../../assets/img/left-11.png" alt="" style="position: absolute;right: 0;top: 0;"> -->
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            CustomerSolutionData:[],
                customerCase:[],
                cases: [
                {
                    index:0,
                    data:[{
                    img: require("../../assets/img/V2.png"),
                    year: "January 2014",
                    description: "Lonking N series 1.5T-3.5T lead-acid/lithium-ion counterbalanced heavy-duty trolley, passed the test in January 2014 and realized mass production till now, with stable use and a failure rate of far less than one in a thousand.",
                    },{
                    img: require("../../assets/img/D1.png"),
                    year: "March 2021",
                    description: "Lonking N series 1.5T-3.5T lead-acid/lithium-ion counterbalanced heavy-duty trolley and E series lithium-ion trolley, which passed the test in March 2021 and realized mass production so far, have been used stably and the failure rate is much lower than one in a thousand.",
                    },{
                    img: require("../../assets/img/G2.png"),
                    year: "March 2023",
                    description: "Lonking N2 series 1.5T-3.5T lead-acid/lithium-ion counterbalanced heavy-duty trolley, E series lithium-ion trolley, passed the test in March 2023 and realized mass production so far, using stable",
                    },] 
                },{
                    index:1,
                    data:[{
                    img: require("../../assets/img/controller/V2总成合力.jpg"),
                    year: "March 2017",
                    description: "HELI H series 1.5-3.8 tons AC electric forklift trucks, test passed in March 2017, and achieve mass production, the failure rate is less than 1500ppm, excellent performance, in the international leading level. In addition exported to Europe, America, Asia and other places."
                    },{
                    img: require("../../assets/img/controller/V2总成合力.jpg"),
                    year: "May 2019",
                    description: "HELI G series lithium special purpose vehicles and three-pivot lithium forklifts, May 2019 test passed, and realize mass production, the failure rate is less than 1500ppm, excellent performance, in the international leading level. In addition, they are exported to Europe, America, Asia and other places."
                    },{
                    img: require("../../assets/img/D1.png"),
                    year: "February 2021",
                    description: "HELI G2 series lithium special-purpose vehicles, October 2020 test passed, and realize mass production so far (forklift), the failure rate is less than 1500ppm, excellent performance, in the international leading level. In addition, they are exported to Europe, America, Asia and other places."
                    },{
                    img: require("../../assets/img/S1.png"),
                    year: "April 2022",
                    description: "HELI G series 1.5-6 tons AC electric tractor, April 2022 test passed, and realize mass production so far (tractor), the failure rate is less than 1500ppm, excellent performance, in the international leading level. In addition, it is exported to Europe, America, Asia and other places."
                    },] 
                },{
                    index:2,
                    data:[{
                    img: require("../../assets/img/S1.png"),
                    year: "2020",
                    description: "HDK's full series of export golf carts were tested and passed in 2020, and all of them have been exported to overseas since then, and the after-sales feedback is better than the performance of European and American brands."
                    },] 
                },{
                    index:3,
                    data:[{
                    img: require("../../assets/img/S1.png"),
                    year: "2021",
                    description: "XCMG high-machine 16m-45m full series of straight and curved jib, passed the test in 2021, mass production so far, customer satisfaction is high, completely replace the European and American products."
                    },{
                    img: require("../../assets/img/S1X.png"),
                    year: "2023",
                    description: "XCMG scissor fork full series, passed the test in 2023, mass production so far, high customer satisfaction, completely replace the European and American products"
                    },] 
                },{
                    index:4,
                    data:[{
                    img: require("../../assets/img/V2.png"),
                    year: "October 2015",
                    description: "KBE series 1.5-3.5 tons all-AC electric forklift, October 2015 test passed, and achieve mass production, the first generation of successful substitution of imported"
                    },{
                    img: require("../../assets/img/D1.png"),
                    year: "October 2019",
                    description: "KBE series three-pivot electric forklift trucks, test passed and mass production in October 2019"
                    },{
                    img: require("../../assets/img/D1.png"),
                    year: "October 2021",
                    description: "KBE series 1.5T-2.0T export vehicles, passed the test in October 2021 and realized mass production, meet the latest EN1175 dual-chip certification, a large number of exported to the European market, and have never received customer complaints."
                    }
                ] 
                },{
                    index:5,
                    data:[{
                    img: require("../../assets/img/V2.png"),
                    year: "January 2020",
                    description: "BYD E-C series 2.5-ton AC electric forklift, which was adopted in January 2020 and has been in mass production since then, with stable quality and the lowest failure rate among similar products."
                    },{
                    img: require("../../assets/img/S1.png"),
                    year: "May 2021",
                    description: "BYD F series 3-ton AC electric forklift, which was adopted in January 2021 and realized mass production so far, with stable quality and the lowest failure rate among similar products."
                    },{
                    img: require("../../assets/img/D1.png"),
                    year: "September 2022",
                    description: "BYD EL series 2~3.5 tons AC electric forklift, September 2022 to carry through, and realize mass production so far, stable quality, the lowest failure rate in the same type of products"
                    }
                ] 
                },{
                    index:6,
                    data:[{
                    img: require("../../assets/img/S1.png"),
                    year: "2020",
                    description: "Linde multidirectional forward moving vehicle, 2020 test passed, and realized mass production so far, customer satisfaction, no anomalies in the feedback"
                    },{
                    img: require("../../assets/img/D1.png"),
                    year: "2022",
                    description: "Linde 3-3.5T counterbalanced forklift trucks, 2022 test passed, and realize mass production to date, compared with imported brands, energy saving of 18%"
                    },
                ] 
                },{
                    index:7,
                    data:[{
                    img: require("../../assets/img/D1.png"),
                    year: "2021",
                    description: "LiuGong lightweight counterbalanced forklift, test passed in 2021, mass production so far, large quantity exported overseas, market failure rate lower than the competition"
                    }
                ] 
                },{
                    index:8,
                    data:[{
                    img: require("../../assets/img/S1.png"),
                    year: "May 2022",
                    description: "2-seater, 4-seater, and 6-seater golf carts/hunting carts, tested in May 2022 and mass-produced to date, stable in use with a failure rate well below 1 in 1,000"
                    },
                ] 
                },{
                    index:9,
                    data:[{
                    img: require("../../assets/img/D1.png"),
                    year: "May 2019",
                    description: "Masier DN series 14~23-seat sightseeing bus, carried through in May 2019 and realized mass production so far, replacing Curtis, received domestic and foreign customers have been highly praised, and continues to be applied to a variety of models"
                    },{
                    img: require("../../assets/img/S1.png"),
                    year: "April 2021",
                    description: "The Marsil EV series of 4~6-seat golf carts was adopted in April 2021 and has been mass-produced since then, replacing Curtis, receiving consistently high praise from domestic and overseas customers, and continuing to be applied to a wide range of models."
                    },{
                    img: require("../../assets/img/S1.png"),
                    year: "April 2022",
                    description: "Maser Hummer series 4~8-seat patrol car, carried through in April 2022, and realized mass production so far, replacing Curtis, received domestic and foreign customers have been well received, and continue to be applied to a variety of vehicles"
                    }
                ] 
                },{
                    index:10,
                    data:[{
                    img: require("../../assets/img/V2.png"),
                    year: "August 2017",
                    description: "Tailift 1.5-3.5-ton all-AC electric forklift, tested and mass-produced in August 2017, the first generation of successful replacement of imported"
                    },{
                    img: require("../../assets/img/D1.png"),
                    year: "August 2020",
                    description: "Tailift 1.5-3.5 tons all-AC electric forklift, test passed in August 2020, and mass production, the second generation to become the main package"
                    },{
                    img: require("../../assets/img/G2.png"),
                    year: "August 2023",
                    description: "Tailift oil-to-electric series 3.5-ton all-AC electric forklift, passed the test in August 2023 and realized mass production, with reliable performance of 2-in-1 electric control and low energy consumption compared to imported brands with the same current."
                    }
                ] 
                },{
                    index:11,
                    data:[{
                    img: require("../../assets/img/S1.png"),
                    year: "June 2022",
                    description: "2-seater, 4-seater and 6-seater golf carts/hunting carts, passed the test in June 2022 and realized mass production so far, stable in use, with performance and quality performance reaching the international similar level"
                    },{
                    img: require("../../assets/img/S1.png"),
                    year: "August 2022",
                    description: "Golf carts 2+2 4+2, tested and mass-produced in August 2022, with performance and quality performance at international level"
                    }
                ] 
                },{
                    index:12,
                    data:[{
                    img: require("../../assets/img/D1.png"),
                    year: "2021",
                    description: "Forlongma ride-on road sweeper series, passed the test in 2021, mass production so far, customer satisfaction, no anomaly feedback."
                    },
                ] 
                },{
                    index:13,
                    data:[{
                    img: require("../../assets/img/G1.png"),
                    year: "May 2023",
                    description: "E800 cleaning sanitation truck, May 2023 test passed, and realized mass production so far, stable use, no failure so far"
                    },{
                    img: require("../../assets/img/G2.png"),
                    year: "May 2023",
                    description: "E800 cleaning sanitation truck, May 2023 test passed, and realized mass production so far, stable use, no failure so far"
                    }
                ] 
                },{
                    index:14,
                    data:[{
                    img: require("../../assets/img/D1.png"),
                    year: "October 2021",
                    description: "Zhongli oil-to-electric series 2.0T-3.5T lithium-electric vehicles, passed the test in October 2021 and realized mass production so far, the use of stable, the failure rate is far less than one thousandth!"
                    }
                ] 
                },{
                    index:15,
                    data:[{
                    img: require("../../assets/img/V2.png"),
                    year: "2018",
                    description: "Zoomlion 1.5-3.5 tons electric forklift, passed the test in 2018, batch so far, no abnormal feedback in the market, better than counterparts"
                    },{
                    img: require("../../assets/img/D1.png"),
                    year: "2020",
                    description: "Zoomlion 1.5-3.5 tons of electric forklift, 2020 test passed, batch so far, the market has no abnormal feedback, better than peers"
                    },{
                    img: require("../../assets/img/S1.png"),
                    year: "2022",
                    description: "Zoomlion Straight Curved Boom Truck, passed the test in 2022, batch to date, no abnormal feedback from the market, better than peers"
                    }
                ] 
                 },{
                    index:16,
                    data:[{
                    img: require("../../assets/img/D1.png"),
                    year: "May 2021",
                    description: "Longchamp 14~23 seater sightseeing bus, May 2021 piggybacking through and realizing mass production so far, replacing Curtis, low failure rate"
                    }
                 ] 
                 }
                ,{
                    index:17,
                    data:[{
                    img: require("../../assets/img/V2.png"),
                    year: "2017",
                    description: "Hang Fork A Series AC Electric Forklift, Test Passed and Mass Production in 2017"         
                    }
                ] 
                },

                
                
                ],
        selectedCase: {
               
        }
            
            
        }
    },
    methods: {
        showCaseInfo(index) {
        this.selectedCase = this.cases[index];
        }
    },
    mounted() {
        // console.log('index', this.$route.query.index);
        // this.customerCase=[];
        // let index =  this.$route.query.index;
        // for (let i = 0; i < this.cases.length; i++) {
            
        //     if(this.cases[i].index==parseInt(index,10)){

        //         this.customerCase=this.cases[i].data;
        //     } 
        // }
        console.log('index', this.$route.query.index);
        let index =  this.$route.query.index;
        let that=this;
       
        this.http.post("/api/FJ_CustomerSolution/GetCustomerSolution?customerid="+parseInt(index,10),JSON.stringify({})).then((result)=>{
            debugger
           let objResult= eval(result);
           let iCode= objResult.code;
           if(iCode==0){
                that.CustomerSolutionData=objResult.data;
            }
        });
       
        // this.http.post("/api/FJ_CustomerSolution/GetCustomerSolution?customerid="+parseInt(index,10),JSON.stringify({})).then((result)=>{
        //     debugger
        //    let objResult= eval(result);
        //    let iCode= objResult.code;
        //    if(iCode==0){
        //         that.CustomerSolutionData=objResult.data;
        //     }
        // });
        
    }
}
</script>

<style scoped>
.header {
    background: url('../../assets/img/casesbanner.jpg') no-repeat;
    background-size: 100%;
}

.w1 {
    width: 1000px;
    margin: auto;
}

.cases-item {
    width: 33.3%;
    padding: 30px;
    box-sizing: border-box;
    border: 1px solid #eee;
}

.cases-item:nth-child(3n - 1) {
    border-left: none;
    border-right: none;
}

/* .products-item.active {
    border-color: #0AA00A;
} */
</style>


// WEBPACK FOOTER //
// src/views/cases/detail.vue